import React, { useEffect } from "react";

function Schedule() {
    useEffect(() => {
        // Create and append the Sessionize script
        const script = document.createElement('script');
        script.src = 'https://sessionize.com/api/v2/eqpauzy4/view/GridSmart';
        script.async = true;
        document.body.appendChild(script);

        // Cleanup function to remove the script when component unmounts
        return () => {
            document.body.removeChild(script);
        };
    }, []); // Empty dependency array ensures this runs only once

    return (
        <div className="bg-transparent mb-0 radius-0">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        {/* Option 1: Using iframe */}
                        <iframe 
                            src="https://sessionize.com/view/eqpauzy4/GridSmart?format=Embed_Styled_Html&isDark=False&title=cackalackycon"
                            style={{
                                width: '100%',
                                height: '800px',
                                border: 'none',
                                backgroundColor: 'transparent'
                            }}
                            title="CackalackyCon Schedule"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Schedule;